<div class="common-confirmation-modal">
	<h1 id="modal_confirm_title">{{ header | translate }} </h1>

	<p class="description"
		id="modal_confirm_description"
		role="article">
		{{ description | translate }}
	</p>

	<div class="packages"
		*ngIf="packages!==undefined && packages.length>0">
		<ul>
			<li *ngFor="let package of packages"
				id="{{'modal_confirm_package_'+package}}">{{ package }}</li>
		</ul>
	</div>

	<div class="options">
		<div class="left-option">
			<vtr-ui-button
				[linkId]="'modal_confirm_ok'"
				(onClick)="onOkClick($event)"
				[upperCaseLabel]=false
				[btnHeight]=true
				[label]="OkText | translate">
			</vtr-ui-button>
		</div>
		<div class="right-option"
			*ngIf="CancelText.length > 0">
			<div role="button"
				class="btn btn-default modal-button-cancel"
				id="modal_confirm_cancel"
				tabindex="0"
				[matTooltip]="CancelText | translate"
				matTooltipClass="vtr-system-tooltip"
				(keydown.enter)="onCancelClick($event)"
				(click)="onCancelClick($event)">
				{{CancelText | translate}}
			</div>
		</div>
	</div>
	<div role="button"
		id="modal_confirm_close"
		title="{{CancelText | translate}}"
		tabindex="0"
		role="button"
		aria-label="close"
		class="close-btn"
		(keydown.enter)="onCancelClick($event)"
		(click)="onCancelClick($event)">
		<img [src]=" 'assets/icons/Close.svg' | svgInline | async"
			alt=""
			srcset="">
	</div>
</div>